import { usePlanExclusions } from '../../../app-init-data';

export type Exclusions = {
	planExclusionId: number;
}[];

export const useExclusionsList = (exclusionList: Exclusions) => {
	const { planExclusions } = usePlanExclusions();

	const quoteExclusions = planExclusions.filter((exclusion) =>
		exclusionList.some((exclusionId) => exclusionId.planExclusionId === exclusion.id)
	);

	return { quoteExclusions };
};
